// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"2e2b08a1","453":"0fa07db4","806":"61c96e92"}[chunkId] + ".chunk.js";
};